import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CRMDashboard from './crm/Dashboard';
import LeadTracker from './crm/LeadTracker';
import DocumentRepository from './crm/DocumentRepository';
import MyTasks from './crm/MyTasks';
import MISReports from './crm/MISReports';
import Companies from './crm/Companies';
import Contacts from './crm/Contacts';
import Consultants from './crm/Consultants';
import ProjectsPipeline from './crm/ProjectsPipeline';
import Competitors from './crm/Competitors';
import PortalAccounts from './crm/PortalAccounts';
import PortalRequestsInbox from './crm/PortalRequestsInbox';

export default function CRM() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app/crm/dashboard" replace />} />
      <Route path="/dashboard" element={<CRMDashboard />} />
      <Route path="/companies" element={<Companies />} />
      <Route path="/contacts" element={<Contacts />} />
      <Route path="/consultants" element={<Consultants />} />
      <Route path="/leads" element={<LeadTracker />} />
      <Route path="/pipeline" element={<ProjectsPipeline />} />
      <Route path="/competitors" element={<Competitors />} />
      <Route path="/portal-accounts" element={<PortalAccounts />} />
      <Route path="/portal-requests" element={<PortalRequestsInbox />} />
      <Route path="/documents" element={<DocumentRepository />} />
      <Route path="/tasks" element={<Navigate to="/app/my-tasks" replace />} />
      <Route path="/reports" element={<MISReports />} />
      {/* Legacy redirects */}
      <Route path="/deals" element={<Navigate to="/app/crm/pipeline" replace />} />
      <Route path="/opportunities" element={<Navigate to="/app/crm/pipeline?view=list" replace />} />
      <Route path="/projects" element={<Navigate to="/app/crm/pipeline" replace />} />
      <Route path="/reminders" element={<Navigate to="/app/my-tasks" replace />} />
      <Route path="/communications" element={<Navigate to="/app/crm/dashboard" replace />} />
    </Routes>
  );
}
